import { MyOrdersPanel } from "./MyOrdersPanel";
import { getStandaloneSpaceId } from "../config";
import "./StandaloneOrdersPage.css";

/** 独立站「我的订单」页（由平台站拷贝，样式后续独立迭代） */
export default function StandaloneOrdersPage(): JSX.Element {
  const spaceId = getStandaloneSpaceId();
  return (
    <div className="standalone-orders-page">
      <div className="standalone-orders-page__inner">
        <h1 className="standalone-orders-page__title">我的订单</h1>
        <MyOrdersPanel spaceId={spaceId} />
      </div>
    </div>
  );
}
